import React from "react";
import "../Loading/style.css";

const Loader = ({ type }) => {
  switch (type) {
    case "full":
      return <div className="loader"></div>;
    case "small":
      return <div className="loader_small"></div>;
    default:
      return <div className="loader"></div>;
  }
};

export default Loader;
